import type { Cart } from '@pylot-data/pylotschema'

/**
 * Carro que useCart entrega a un invitado que todavía no tiene carro.
 *
 * El carro se crea recién al agregar el primer producto (ver ensureCart), así
 * que antes de eso no hay cart_id que consultar. En vez de pedir `cart(cart_id: "")`
 * (Magento responde con error y el minicart lo muestra como toast) se entrega
 * este objeto, que replica lo que Magento devuelve para un carro vacío recién
 * creado. Así el minicart, el contador del header y la redirección del checkout
 * vacío se comportan igual que cuando el carro se creaba al cargar la página.
 *
 * `id` vacío indica que no existe en el backend: los hooks de agregar al carro
 * lo detectan y llaman a ensureCart antes de la mutación.
 */
export const getEmptyGuestCart = (): Cart =>
    ({
        id: '',
        email: null,
        is_virtual: false,
        checkoutUrl: null,
        items: [],
        prices: {
            __typename: 'CartPrices',
            grand_total: { value: 0, currency: 'CLP' },
            applied_taxes: [],
            subtotal_including_tax: { value: 0, currency: 'CLP' },
            subtotal_excluding_tax: { value: 0, currency: 'CLP' },
            subtotal_with_discount_excluding_tax: { value: 0, currency: 'CLP' },
            discounts: [{ amount: { value: null, currency: 'CLP' } }]
        },
        shipping_addresses: [],
        billing_address: null,
        selected_payment_method: { code: '', title: '' },
        available_payment_methods: [
            { code: 'free', title: 'No Payment Information Required' }
        ],
        applied_coupons: null,
        applied_gift_cards: []
    }) as unknown as Cart
